import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate, Link } from 'react-router-dom';
import '../../styles/login.css';
import Popup from '../../components/Popup';

function Register() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [popup, setPopup] = useState({
    isOpen: false,
    title: '',
    message: '',
    type: '',
    showCancelButton: false,
    onConfirm: () => {}
  });
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setPopup({
        isOpen: true,
        title: 'Lỗi',
        message: 'Mật khẩu xác nhận không khớp',
        type: 'error',
        showCancelButton: false,
        onConfirm: () => setPopup({ isOpen: false })
      });
      return;
    }

    if (password.length < 6) {
      setPopup({
        isOpen: true,
        title: 'Lỗi',
        message: 'Mật khẩu phải có ít nhất 6 ký tự',
        type: 'error',
        showCancelButton: false,
        onConfirm: () => setPopup({ isOpen: false })
      });
      return;
    }

    setIsLoading(true);
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/auth/register`, {
        email,
        password
      });
      localStorage.setItem('token', response.data.token);
      navigate('/create-room');
    } catch (error) {
      setPopup({
        isOpen: true,
        title: 'Lỗi',
        message: error.response?.data?.error || 'Có lỗi xảy ra',
        type: 'error',
        showCancelButton: false,
        onConfirm: () => setPopup({ isOpen: false })
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      <Popup {...popup} />
      
      <div className="login-box">
        <div className="login-header">
          <i className="fas fa-user-plus login-icon"></i>
          <h1>Đăng ký tài khoản</h1>
          <p className="login-subtitle">Tạo tài khoản để bắt đầu sử dụng</p>
        </div>

        <div className="login-form">
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <div className="input-group">
                <span className="input-group-text">
                  <i className="fas fa-envelope"></i>
                </span>
                <input
                  type="email"
                  className="form-control"
                  placeholder="Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  disabled={isLoading}
                />
              </div>
            </div>

            <div className="form-group">
              <div className="input-group">
                <span className="input-group-text">
                  <i className="fas fa-lock"></i>
                </span>
                <input
                  type="password"
                  className="form-control"
                  placeholder="Mật khẩu"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  disabled={isLoading}
                />
              </div>
            </div>

            <div className="form-group">
              <div className="input-group">
                <span className="input-group-text">
                  <i className="fas fa-lock"></i>
                </span>
                <input
                  type="password"
                  className="form-control"
                  placeholder="Xác nhận mật khẩu"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                  disabled={isLoading}
                />
              </div>
            </div>

            <button 
              type="submit" 
              className="btn btn-primary btn-block"
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <i className="fas fa-spinner fa-spin me-2"></i>
                  Đang đăng ký...
                </>
              ) : (
                <>
                  <i className="fas fa-user-plus me-2"></i>
                  Đăng ký
                </>
              )}
            </button>
          </form>

          <div className="login-footer">
            <p>Đã có tài khoản? <Link to="/login">Đăng nhập ngay</Link></p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Register; 